/**
 * Contrato entre el gate / el wizard y `/login` para el usuario al que le
 * retiraron el acceso (7-sep-2026).
 *
 * Cuando `GET /onboarding/context` responde `access_revoked: true` (no es
 * staff, no tiene membership activa y al menos una le fue revocada), ni el
 * shell ni el wizard tienen nada que ofrecerle: se lo manda a `/login` con
 * este motivo, y es `/login` quien cierra la sesión y explica por qué.
 */
export const ACCESO_RETIRADO_PARAM = "motivo";
export const ACCESO_RETIRADO_VALUE = "acceso-retirado";
export const LOGIN_ACCESO_RETIRADO = `/login?${ACCESO_RETIRADO_PARAM}=${ACCESO_RETIRADO_VALUE}`;
